import { Version } from "./Version";

export type Pref = {
  displayLengthPerPage: number;
  musicRow: {
    diffTextColorType: "A" | "B" | "C" | "D";
  };
  textage: {
    spPlaySide: 1 | 2;
    highSpeed: 0 | 1 | 2 | 3;
    slim: boolean;
  };
  share: {
    maxSplit: number;
    rowPerPage: number;
    blankImage: boolean;
  };
  defaultMusicQuery: {
    sp: number | null;
    dp: number | null;
  };
  theme: {
    color: Version | -1;
  };
};

export const DEFAULT_PREF: Pref = {
  displayLengthPerPage: 20,
  musicRow: {
    diffTextColorType: "A",
  },
  textage: {
    spPlaySide: 1,
    highSpeed: 1,
    slim: false,
  },
  share: {
    maxSplit: 1,
    rowPerPage: 15,
    blankImage: false,
  },
  defaultMusicQuery: {
    sp: null,
    dp: null,
  },
  theme: {
    color: -1,
  },
};
